import React from "react";

const principles = [
  "Responsible AI",
  "Learning intelligence",
  "Human-centered care",
];

const visionPillars = [
  {
    label: "Vision",
    title: "Personalized support across every learning stage.",
    text: "We want AI to help families, educators, and institutions understand needs earlier and respond with confidence.",
  },
  {
    label: "Research",
    title: "Models grounded in human development signals.",
    text: "Our work focuses on multimodal understanding, including sound, behavior, and learning context.",
  },
  {
    label: "Deployment",
    title: "Practical products, not abstract demos.",
    text: "We translate research into trusted tools for classrooms, homes, and care teams.",
  },
];

export const About = (props) => {
  const intro =
    props.data?.paragraph ||
    "CradleAI builds trusted AI systems for education, child development, and human-centered learning.";

  return (
    <section id="about" className="about-section">
      <div className="container about-shell">
        <div className="about-grid">
          <div className="about-copy">
            <p className="section-kicker">About CradleAI</p>
            <h2>AI for human learning</h2>
            <p className="about-lede">{intro}</p>
            <p className="about-detail">
              Our vision is to build responsible AI systems that make learning more adaptive, early development more understandable, and care decisions more evidence-informed. By connecting research models with real-world educational and caregiving contexts, we aim to help people recognize needs earlier and respond with greater confidence.
            </p>

            <div className="about-principles" aria-label="CradleAI principles">
              {principles.map((item) => (
                <div className="about-principle" key={item}>
                  <span aria-hidden="true" />
                  <p>{item}</p>
                </div>
              ))}
            </div>
          </div>

          <div className="about-visual">
            <div className="about-image-frame">
              <img
                src="img/about.jpg"
                alt="CradleAI education technology and AI research"
              />
            </div>
          </div>
        </div>

        <div className="about-vision-grid">
          {visionPillars.map((pillar) => (
            <article className="about-vision-card" key={pillar.label}>
              <span>{pillar.label}</span>
              <h3>{pillar.title}</h3>
              <p>{pillar.text}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};
